export const SET_MOVIES = "SET_MOVIES";
export const REMOVE_MOVIES = "REMOVE_MOVIES";
